import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { TwoFactorSetup } from '../components/auth/TwoFactorSetup';
import { useAuth } from '../hooks/useAuth';

export const TwoFactorRequired: React.FC = () => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const { user, updateUser, logout } = useAuth();

  const handleSetupComplete = async () => {
    toast.current?.show({
      severity: 'success',
      summary: 'Success',
      detail: 'Two-factor authentication has been enabled. You can now continue.',
      life: 3000,
    });

    // Refresh user data to get updated 2FA status
    await updateUser();

    // Navigate to home after a short delay
    setTimeout(() => {
      navigate('/');
    }, 1500);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="auth-layout">
      <Toast ref={toast} />

      <Card className="auth-card two-factor-setup-card">
        <div className="auth-header">
          <img src="/tallai-icon.png" alt="TallAI" />
          <h1>tall<b>ai</b></h1>
        </div>

        <div className="two-factor-intro">
          <h2>Two-Factor Authentication Required</h2>
          <p>
            {user?.full_name ? `Hi ${user.full_name}, ` : ''}
            To continue using TallAI, you need to enable two-factor authentication for your account.
          </p>
          <p className="security-notice">
            <i className="ms-out ms-out-security" />
            This adds an extra layer of security to protect your account and data.
          </p>
        </div>

        <TwoFactorSetup onComplete={handleSetupComplete} />

        <div className="auth-footer">
          <Button
            label="Sign out and use a different account"
            link
            size="small"
            onClick={handleLogout}
          />
        </div>
      </Card>
    </div>
  );
};

export default TwoFactorRequired;
